import { Injectable } from '@angular/core';
import { ContactDetailsService } from '../contact-details.service';
import { BehaviorSubject } from 'rxjs';
import { ContactHistory } from '../contacts-details.model';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const SearchDirection = {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER'
};

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  public limit = 5;
  public history: ContactHistory[];
  private totalHistoryEventsBefore: number;
  private totalHistoryEventsAfter: number;
  private searchType: string;
  public onUpdateHistory = new BehaviorSubject<any>(opener);

  constructor(public contactDetailsService: ContactDetailsService) {}

  loadHistory(contactId: number, contactEventId: number, limit = this.limit, searchType = '') {
    this.contactDetailsService
      .getContactHistory({
        contactId: contactId,
        eventId: contactEventId,
        limit: limit,
        type: searchType
      })
      .subscribe((res: ContactHistory[]) => {
        this.addToListingBefore(res);
      });
  }

  setValues(searchType, history) {
    this.searchType = searchType;
    this.history = history;
  }

  addToListingBefore(historyList: ContactHistory[]) {
    this.totalHistoryEventsBefore = historyList.length;
    this.history = [...this.history, ...historyList];
    this.getHistory(this.history);
  }

  addToListingAfter(historyList: ContactHistory[]) {
    this.totalHistoryEventsAfter = historyList.length;
    this.history = [...historyList, ...this.history];
    this.getHistory(this.history);
  }

  chooseType(type: string, contactId: number, eventId: number) {
    this.setValues(type, []);
    this.loadHistory(contactId, eventId, this.limit, type);
  }

  getHistory(historyList: ContactHistory[]) {
    this.onUpdateHistory.next(historyList);
  }

  refreshHistory(contactId: number, contactEventId = null) {
    this.history = [];
    this.totalHistoryEventsAfter = this.totalHistoryEventsBefore = null;
    this.loadHistory(contactId, contactEventId);
  }

  prependHistory(contactId: number) {
    this.contactDetailsService
      .getContactHistory({
        contactId: contactId,
        eventId: this.history[0].id,
        limit: this.limit,
        searchDirection: SearchDirection.AFTER,
        type: this.searchType
      })
      .subscribe((res: ContactHistory[]) => {
        this.addToListingAfter(res);
      });
  }

  appendHistory(contactId: number) {
    this.contactDetailsService
      .getContactHistory({
        contactId: contactId,
        eventId: this.history[this.history.length - 1].id,
        limit: this.limit,
        searchDirection: SearchDirection.BEFORE,
        type: this.searchType
      })
      .subscribe((res: ContactHistory[]) => {
        this.addToListingBefore(res);
      });
  }

  isAvailableMoreHistoryAfter() {
    return this.totalHistoryEventsAfter === null || this.totalHistoryEventsAfter >= this.limit;
  }

  isAvailableMoreHistoryBefore() {
    return this.totalHistoryEventsBefore === null || this.totalHistoryEventsBefore >= this.limit;
  }

  getIsoCountry(number: string) {
    const parsedNumber = parsePhoneNumberFromString(number);
    return parsedNumber && parsedNumber.country.toLowerCase();
  }
}
